export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.clientId = payload;
  return newState;
};
